import React from "react";
import type { YesNo } from "../types";

export function YesNoRadio({
  name,
  value,
  onChange,
  label,
  error,
  disabled,
}: {
  name: string;
  value: YesNo | null;
  onChange: (v: YesNo) => void;
  label?: React.ReactNode;
  error?: string;
  disabled?: boolean;
}) {
  return (
    <div>
      {label && <span className="field-label">{label}</span>}
      <div className="flex gap-4" role="radiogroup" aria-label={typeof label === "string" ? label : name}>
        <label className="inline-flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={name}
            value="Yes"
            checked={value === "Yes"}
            onChange={() => onChange("Yes")}
            disabled={disabled}
            className="h-4 w-4 border-slate-300 text-program focus:ring-program"
          />
          <span className="text-sm">Yes</span>
        </label>
        <label className="inline-flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={name}
            value="No"
            checked={value === "No"}
            onChange={() => onChange("No")}
            disabled={disabled}
            className="h-4 w-4 border-slate-300 text-program focus:ring-program"
          />
          <span className="text-sm">No</span>
        </label>
      </div>
      {error && <p className="field-error">{error}</p>}
    </div>
  );
}
